import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=548ff2cc&scoped=true"
import script from "./Step1.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Step1.vue?vue&type=style&index=0&id=548ff2cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ff2cc",
  null
  
)

export default component.exports